import React, { useEffect, useState } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import axios from "axios";
import "../../styles/App.css";

const RoomsPage = () => {
  const [rooms, setRooms] = useState([]);
  const [dormitories, setDormitories] = useState([]);
  const [search, setSearch] = useState("");
  const [editingRoom, setEditingRoom] = useState(null);
  const [form, setForm] = useState({
    dormitory_id: "",
    floor_number: "",
    room_number: "",
    beds_count: "",
    beds_description: "",
  });
  const API = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    fetchRooms();
    fetchDormitories();
  }, []);

  const fetchRooms = async () => {
    try {
      const res = await axios.get(`${API}/api/admin-rooms/`, {
        headers: { Authorization: getAuthHeader() },
      });
      setRooms(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchDormitories = async () => {
    try {
      const res = await axios.get(`${API}/api/admin-rooms/admin-dormitories`, {
        headers: { Authorization: getAuthHeader() },
      });
      setDormitories(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id, roomNumber) => {
    const confirmDelete = window.confirm(
      `Ви впевнені, що хочете видалити кімнату ${roomNumber}?`
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(`${API}/api/admin-rooms/${id}`, {
        headers: { Authorization: getAuthHeader() },
      });
      fetchRooms();
    } catch (err) {
      if (err.response && err.response.status === 400) {
        alert(err.response.data.message); 
      } else {
        console.error(err);
      }
    }
  };

  const handleEdit = (room) => {
    setEditingRoom(room.id);
    setForm(room);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingRoom) {
        await axios.put(`${API}/api/admin-rooms/${editingRoom}`, form, {
          headers: { Authorization: getAuthHeader() },
        });
      } else {
        await axios.post(`${API}/api/admin-rooms/`, form, {
          headers: { Authorization: getAuthHeader() },
        });
      }
      setEditingRoom(null);
      setForm({
        dormitory_id: "",
        floor_number: "",
        room_number: "",
        beds_count: "",
        beds_description: "",
      });
      fetchRooms();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="page-container">
      <h3 className="header-content-title">
        Якщо тут пусто - сплив термін JWT-токена, необхідно перезайти в
        обліковий запис.
      </h3>

      <input
        className="search-input"
        type="text"
        placeholder="Пошук за номером кімнати або описом ліжок..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <form onSubmit={handleSubmit} className="header-content">
        <select
          className="header-content-input"
          value={form.dormitory_id}
          onChange={(e) => setForm({ ...form, dormitory_id: e.target.value })}
          required
        >
          <option value="">Оберіть гуртожиток</option>
          {dormitories.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
        <input
          className="header-content-input"
          type="number"
          placeholder="Поверх"
          value={form.floor_number}
          onChange={(e) => setForm({ ...form, floor_number: e.target.value })}
          required
        />
        <input
          className="header-content-input"
          type="text"
          placeholder="Номер кімнати"
          value={form.room_number}
          onChange={(e) => setForm({ ...form, room_number: e.target.value })}
          required
        />
        <input
          className="header-content-input"
          type="number"
          placeholder="Кількість ліжок"
          value={form.beds_count}
          onChange={(e) => setForm({ ...form, beds_count: e.target.value })}
          required
        />
        <textarea
          className="header-content-input"
          style={{ height: "18px" }}
          placeholder="Опис ліжок"
          value={form.beds_description}
          onChange={(e) =>
            setForm({ ...form, beds_description: e.target.value })
          }
        />
        <button type="submit" className="admin-add-button">
          {editingRoom ? "Оновити" : "Додати"}
        </button>
      </form>

      <table className="table">
        <thead>
          <tr>
            <th className="table-header">Гуртожиток</th>
            <th className="table-header">Поверх</th>
            <th className="table-header">Номер кімнати</th>
            <th className="table-header">Кількість ліжок</th>
            <th className="table-header">Опис ліжок</th>
            <th className="table-header">Дії</th>
          </tr>
        </thead>
        <tbody>
          {rooms
            .filter(
              (r) =>
                r.room_number.includes(search) ||
                r.beds_description.includes(search)
            )
            .map((room) => (
              <tr key={room.id}>
                <td className="table-content">{room.dormitory_name}</td>
                <td className="table-content">{room.floor_number}</td>
                <td className="table-content">{room.room_number}</td>
                <td className="table-content">{room.beds_count}</td>
                <td className="table-content">{room.beds_description}</td>
                <td className="table-content">
                  <div className="admin-button-container">
                    <button
                      className="admin-edit-button"
                      onClick={() => handleEdit(room)}
                    >
                      ✏️
                    </button>
                    <button
                      className="admin-edit-button"
                      onClick={() => handleDelete(room.id, room.room_number)}
                    >
                      🗑️
                    </button>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default RoomsPage;
